<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent&& localService.languageContent.table && localService.languageContent.tasks && wrapper">
    <div class="banner center" style="margin-top:10px;max-width: 1400px;">
        <div>
            <div class="row freeze_height" *ngIf="wrapper">
                <div class="col-3">
                    <ngx-select *ngIf="!isParentTaskAvailable" [disabled]="isRestricted"
                        placeholder="{{localService.languageContent.tasks.filter_owner}}"
                        title="{{localService.languageContent.tasks.filter_owner}}" [(ngModel)]="selectedTaskOwner"
                        [noAutoComplete]="false" [items]="wrapper.options" [optionValueField]="'key'"
                        [optionTextField]="'selectedValueKey'" [allowClear]="!isRestricted" (select)="onLoad()"
                        (remove)="onLoad()">
                        <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                            <div title="{{option.data.key}}" class="select_option">
                                <div>
                                    {{option.data.s_value}}
                                </div>
                            </div>
                        </ng-template>
                    </ngx-select>
                    <ngx-select *ngIf="isParentTaskAvailable"
                        placeholder="{{localService.languageContent.tasks.filter_owner_child}}"
                        title="{{localService.languageContent.tasks.filter_owner_child}}"
                        [(ngModel)]="selectedTaskOwnerChild" [noAutoComplete]="false" [items]="wrapper.options"
                        [optionValueField]="'key'" [optionTextField]="'selectedValueKey'" [allowClear]="true"
                        (select)="onLoad()" (remove)="onLoad()">
                        <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                            <div title="{{option.data.key}}" class="select_option">
                                <div>
                                    {{option.data.s_value}}
                                </div>
                            </div>
                        </ng-template>
                    </ngx-select>
                </div>
                <div class="col-3">
                    <ngx-select *ngIf="!isParentTaskAvailable" style="width: calc(100% - 100px);"
                        [(ngModel)]="selectedTaskType" [optionValueField]="'key'" [optionTextField]="'value'"
                        [items]="wrapper.configs_1" [noAutoComplete]="false"
                        placeholder="{{localService.languageContent.tasks.filter_task_type}}"
                        title="{{localService.languageContent.tasks.filter_task_type}}" [allowClear]="true"
                        (select)="onLoad()" (remove)="onLoad()">
                    </ngx-select>
                    <ngx-select *ngIf="isParentTaskAvailable" style="width: calc(100% - 100px);"
                        [(ngModel)]="selectedTaskTypeChild" [optionValueField]="'key'" [optionTextField]="'value'"
                        [items]="wrapper.configs_1" [noAutoComplete]="false"
                        placeholder="{{localService.languageContent.tasks.filter_task_type_child}}"
                        title="{{localService.languageContent.tasks.filter_task_type_child}}" [allowClear]="true"
                        (select)="onLoad()" (remove)="onLoad()">
                    </ngx-select>
                </div>
                <div class="col-2">
                    <ngx-select *ngIf="!isParentTaskAvailable" style="width: calc(100% - 100px);"
                        [(ngModel)]="selectedTaskStatus" [optionValueField]="'key'" [optionTextField]="'value'"
                        [items]="wrapper.configs_2" [noAutoComplete]="false"
                        placeholder="{{localService.languageContent.tasks.filter_task_status}}"
                        title="{{localService.languageContent.tasks.filter_task_status}}" [allowClear]="true"
                        (select)="onLoad()" (remove)="onLoad()">
                    </ngx-select>
                    <ngx-select *ngIf="isParentTaskAvailable" style="width: calc(100% - 100px);"
                        [(ngModel)]="selectedTaskStatusChild" [optionValueField]="'key'" [optionTextField]="'value'"
                        [items]="wrapper.configs_2" [noAutoComplete]="false"
                        placeholder="{{localService.languageContent.tasks.filter_task_status_child}}"
                        title="{{localService.languageContent.tasks.filter_task_status_child}}" [allowClear]="true"
                        (select)="onLoad()" (remove)="onLoad()">
                    </ngx-select>
                </div>
                <div class="col-4" style="text-align: right;">
                    <div class="row">
                        <div class="col-6" *ngIf="!isRestricted">
                            <button type="button" style="width: 100%;" class="btn btn-primary"
                                [disabled]="isParentTaskAvailable" (click)="onAction(7)">
                                <div class="wrap-div">
                                    <i class="material-icons icon_adjust" style="color: white;">notifications_active</i>
                                    <span>
                                        {{localService.languageContent.tasks.send_alert }}
                                    </span>
                                </div>
                            </button>
                        </div>
                        <div [ngClass]="isRestricted ? 'col-12' : 'col-6'">
                            <button type="button" style="width: 100%;" class="btn btn-primary" (click)="onAction(1)">
                                <div class="wrap-div">
                                    <i class="material-icons icon_adjust" style="color: white;">add_task</i>
                                    <span>
                                        {{isParentTaskAvailable ? localService.languageContent.tasks.add_sub_task :
                                        localService.languageContent.tasks.new_work_item }}
                                    </span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row freeze_height" *ngIf="wrapper?.content?.content && isParentTaskAvailable">
                <div class="col-7">
                    <app-label [Text]="localService.languageContent.tasks.title" />
                    <span>&nbsp;{{wrapper.content.content.v1}}</span>
                </div>
                <div class="col-5">
                    <app-label [Text]="localService.languageContent.tasks.work_item_number" />
                    <span>&nbsp;{{wrapper.content.content.v2}}</span>
                </div>
            </div>
            <div class="row row_header freeze_col freeze_height">
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-8">
                            <button class="button_icon button_icon_color" (click)="onAction(5)"
                                *ngIf="isParentTaskAvailable" style="float: left;">
                                arrow_back
                            </button>
                            {{localService.languageContent.tasks.task_number}}
                        </div>
                        <div class="col-4">
                            {{localService.languageContent.tasks.eta_short}}
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="row">
                        <div class="col-7">
                            {{localService.languageContent.tasks.task_type}}
                        </div>
                        <div class="col-5">
                            {{localService.languageContent.tasks.task_status}}
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    {{localService.languageContent.tasks.owner}}
                </div>
            </div>
        </div>
        <div class="custom_rows_body" style="max-width: 1400px;max-height: calc(100vh - 220px);">
            <div *ngFor="let item of wrapper.content.items">
                <div class="row styled_row freeze_height" title="{{item.v1}}">
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-8">
                                <button class="button_icon button_icon_color icon_adjust"
                                    (click)="onAction(2,item.key)">
                                    edit
                                </button>
                                <button class="button_icon button_icon_color icon_adjust " *ngIf="!isRestricted"
                                    title="{{localService.languageContent.common.send_to_phone}}"
                                    (click)="onAction(3,item.key)">send_to_mobile</button>
                                <button class="button_icon button_icon_color icon_adjust "
                                    *ngIf="!isParentTaskAvailable"
                                    title="{{localService.languageContent.tasks.navigate_to_tasks}}"
                                    (click)="onAction(4,item.key)">group_work</button>
                                <button class="button_icon button_icon_color icon_adjust " *ngIf="isParentTaskAvailable"
                                    title="{{localService.languageContent.tasks.clone_task}}"
                                    (click)="onAction(6,item.key)">content_copy</button>
                                <span class="en">
                                    {{item.v7}}
                                </span>
                            </div>
                            <div class="col-4">
                                <div class="wrap-div">
                                    <span class="en">
                                        {{item.v2 | date : 'dd-MMM-yyyy'}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="row">
                            <div class="col-7">
                                {{item.v4}}
                            </div>
                            <div class="col-5">
                                {{item.v5}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        {{item.v8}}
                    </div>
                    <div class="wrap-div comments">
                        {{item.v9}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="wrapper.content && wrapper.content" [paging]="wrapper.content.paging" [IsShowDateRange]="true"
        (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<div>
    <app-task-request *ngIf="wrapper" [(isOpenPopup)]="isTaskRequestPopupOpen" [taskId]="selectedTaskId"
        [taskTypes]="wrapper.configs_1" [taskStatuses]="wrapper.configs_2" [parentTaskNumber]="parentTaskNumber"
        [taskOwners]="wrapper.options" (onClose)="onLoad()" />
    <app-send-to-phone *ngIf="isOpenSendToPhone" [(isOpen)]="isOpenSendToPhone" [key]="selectedTaskId"
        [communicationTemplate]="CommunicationTemplate.TaskAssigned" />
</div>